<template>
  <DatePicker
    v-model="date"
    :disabled="disabled"
    :clearable="clearable"
    :size="size"
    :start-placeholder="resolvedStartPlaceholder"
    :end-placeholder="resolvedEndPlaceholder"
    type="daterange"
    :range-separator="rangeSeparator"
    :picker-options="pickerOptions"
    @change="handleChange"
  />
</template>

<script>
import { DatePicker } from 'element-ui';
import moment from 'moment';

export default {
  components: {
    DatePicker,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      type: Array,
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: 'large',
    },

    placeholder: {
      type: String,
      default: '预计释放时间',
    },

    startPlaceholder: {
      type: String,
      default: '',
    },

    endPlaceholder: {
      type: String,
      default: '',
    },

    rangeSeparator: {
      type: String,
      default: '-',
    },

    disabledDate: {
      type: Function,
      default(time) {
        const minTime = moment().add(0, 'day').startOf('day').valueOf();
        const maxTime = moment().add(7, 'day').endOf('day').valueOf();
        const currentTime = time.getTime();

        return currentTime < minTime || currentTime > maxTime;
      },
    },
  },

  data() {
    return {
      date: this.value,
    };
  },

  computed: {
    resolvedStartPlaceholder() {
      return this.startPlaceholder || this.placeholder;
    },

    resolvedEndPlaceholder() {
      return this.endPlaceholder || this.placeholder;
    },

    pickerOptions() {
      return {
        disabledDate: this.disabledDate,
      };
    },
  },

  watch: {
    value(newVal) {
      this.date = newVal;
    },
  },

  methods: {
    handleChange() {
      if (!Array.isArray(this.date) || this.date.length !== 2) {
        this.$emit('change', this.date);
        return;
      }

      const [startDate, endDate] = this.date;
      this.$emit('change', [moment(startDate), moment(endDate)]);
    },
  },
};
</script>

<style>
  .in-range:not([class*="-date"]) > div{
      background: #1890ff!important;
      border-radius: 4px!important;
      color: #fff!important;
      margin: 0px 4px;
  }
</style>
